import { render, staticRenderFns } from "./text-box.vue?vue&type=template&id=f1817720&scoped=true"
import script from "./text-box.vue?vue&type=script&lang=js"
export * from "./text-box.vue?vue&type=script&lang=js"
import style0 from "./text-box.vue?vue&type=style&index=0&id=f1817720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1817720",
  null
  
)

export default component.exports